import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatMessageTimestamp = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.grey[400],
  fontSize: 10,
  textAlign: 'right',
}));
